module.exports = __webpack_public_path__ + "img/paifeng02.5ec07892.png";